import './bootstrap';
require('./form_utils')
require('./savy.min')
import('jquery')
import('bootstrap-datepicker')

jQuery(document).ready(function($) {
    $('.datepicker').datepicker({
        format: 'dd/mm/yyyy'
    });
});
